export default function getCDNImagePath(path: string, vite?: true): string {
    const baseCDNUrl = vite
        ? (import.meta.env.VITE_IMAGE_SERVE_HOST as string)
        : process.env.EXPO_PUBLIC_IMAGE_SERVE_HOST;
    return `${baseCDNUrl!}/${path}`;
}
